(function () {
    //get the formApp module
    var formApp = angular.module('formApp');
    // this controller will take care of the navigation bar
    formApp.controller('navigationController', ['$scope', 'DataServices', 'UtilityServices', 'ValidationService', '$filter', '$location', function ($scope, DataServices, UtilityServices, ValidationService, $filter, $location) {
        $scope.utility = UtilityServices;
        $scope.vs = ValidationService; //required to be able to eval page.condition expressions from the survey JSON on this scope
        $scope.curPageNumber = 0;

        $scope.init = function (configData, curPageNumber) {
            $scope.configData = configData;
            $scope.curPageNumber = curPageNumber;
        }

        // Create a list of the page info so it can be displayed in the progress meter
        var index = 0;
        $scope.pageList = new Array();
        $.each($filter('filter')($scope.configData.navigationTabs, { includeInProgress: true }, false), function () {
            $scope.pageList.push({ index: index, number: this.number, title: this.title, pages: this.pages });
            index++;
        });

        // Navigates to a specific page from the progress bar
        $scope.goToPage = function (tabNo, pageUrl) {
            curPath = $location.$$path.substring(1, $location.$$path.indexOf('/', 1));
            var dhordffhPath = $location.$$path.split('/')[2];
            if (!$scope.page.exitCondition) {
                if ($location.path().indexOf('DFFH') > -1) {
                    $location.path('DFFH/'+ dhordffhPath + '/' + tabNo + "/" + pageUrl);
                }
                else if ($location.path().indexOf('DH') > -1) {
                    $location.path('DH/' + dhordffhPath + '/' + tabNo + "/" + pageUrl);
                }
                else {
                    $location.path(curPath + '/' + tabNo + "/" + pageUrl);
                }
            }
            else {
                var successFunction = function () {
                    if ($location.path().indexOf('DFFH') > -1) {
                        $location.path('DFFH/' + dhordffhPath + '/' + tabNo + "/" + pageUrl);
                    }
                    else if ($location.path().indexOf('DH') > -1) {
                        $location.path('DH/' + dhordffhPath + '/' + tabNo + "/" + pageUrl);
                    }
                    else {
                        $location.path(curPath + '/' + tabNo + "/" + pageUrl);
                    }
                };
                var failureFunction = function () { $scope.utility.openPopup($scope.page.exitConditionPopup); };
                $scope.$eval($scope.page.exitCondition, { successFunction: successFunction, failureFunction: failureFunction, nextPageUrl: pageUrl });
            }
        }

        // Navigate to a specific navigation tab from the progress bar
        $scope.goToNavigationTab = function (tabNo) {
            // go to the first page in the selected tab
            var navTab = _.find($scope.configData.navigationTabs, function (o) { return o.number == tabNo; });
            var pageUrl = navTab.pages[0].url;

            $scope.goToPage(tabNo, pageUrl);
        }

        $scope.isDHReadOnlyComplaint = function () {
            if (($location.path().indexOf('DH/complaint') > -1) || ($location.path().indexOf('DH/complaintRegistered') > -1)) {
                if ($scope.IsDHVisible && $scope.isPageEditable === false) {
                    return true;
                }
            }
            return false;
        }

    }]);
}());